var _excluded = ["to", "href"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import getLinkPropsFromUrl from './getLinkPropsFromUrl';
import { Link as ReactRouterLink } from 'react-router-dom'; // this utility HOC allows us to be flexible about whether our link
// components are internal links (handled by react-router) or external links
// (which should render regular a tags)

var SmartLink = function SmartLink(_ref) {
  var to = _ref.to,
      href = _ref.href,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (!to && !href) return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, rest));
  var urlProps = getLinkPropsFromUrl(to || href);
  var Component = !urlProps.to ? 'a' : ReactRouterLink;
  return /*#__PURE__*/React.createElement(Component, _extends({}, urlProps, rest));
};

export default SmartLink;